/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React from 'react';
import { apiVerifyProductFiles, apiMoveFiles, apiRequestDoC } from 'api';

export const ProductFileManagementContext = React.createContext({});

const handleResponse = (response) => {
  const { status } = response || {};
  if (status >= 200 && status <= 299) {
    return response.data;
  }
  throw response;
};
export const ProductFileManagementProvider = ({ children, productId, onRefresh }) => {
  // Verify File
  const verifyFile = React.useCallback(
    async (fileId, status, notes = '', callback) => {
      try {
        const result = await apiVerifyProductFiles(productId, fileId, { status, verifyNotes: notes });
        handleResponse(result);
        onRefresh && onRefresh();
      } catch (ex) {
        console.error('Verify', ex);
      } finally {
        callback();
      }
    },
    [productId]
  );
  // Move File
  const moveFiles = React.useCallback(
    async (fileIds, parentId, callback) => {
      try {
        const result = await apiMoveFiles(productId, {
          fileIds,
          data: {
            parentId,
          },
        });
        handleResponse(result);
        onRefresh && onRefresh();
      } catch (ex) {
        console.error('Verify', ex);
      } finally {
        callback();
      }
    },
    [productId]
  );
  // Request DoC.
  const requestDoC = React.useCallback(
    async (fileIds, callback) => {
      try {
        const result = await apiRequestDoC(productId, fileIds);
        handleResponse(result);
        // onRefresh && onRefresh();
      } catch (ex) {
        console.error('Verify', ex);
      } finally {
        callback();
      }
    },
    [productId]
  );

  return (
    <ProductFileManagementContext.Provider
      value={{
        verifyFile,
        moveFiles,
        requestDoC,
      }}>
      {React.Children.only(children)}
    </ProductFileManagementContext.Provider>
  );
};
